import { RISK_API } from '../../helpers/app-config';

const LIMIT_API = 'limit-status/v1';

export function getRiskApiUrl(clientName: string): string {
    return [
        RISK_API.PROTOCOL,
        '://',
        RISK_API.ADDRESS,
        ':',
        RISK_API.PORT,
        '/',
        LIMIT_API,
        '/',
        clientName,
    ].join('');
}
